<template>
  <el-card>
    <header slot="header">
      <h2>Manage Roles</h2>
    </header>
    
    <section>
      <el-table v-loading="loading" :data="roles" style="width: 100%;">
        <el-table-column
          label="Name"
          prop="display_name">
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-button 
              plain
              type="success"
              size="mini" 
              @click="$router.push({ name: 'roles.create' })">
              Create
            </el-button>
          </template>
          <template slot-scope="scope">
            <el-button
              plain
              type="primary"
              size="mini"
              @click="$router.push(`/roles/${scope.row.id}`)">Edit</el-button>
            <el-popconfirm 
              :title="`Are you sure to delete the ${scope.row.display_name || scope.row.name} role?`"
              confirmButtonText="Delete"
              cancelButtonText="Cancel"
              icon="el-icon-info"
              iconColor="red"
              @onConfirm="handleDelete(scope.row)">
              <el-button
                plain
                slot="reference"
                size="mini"
                icon="el-icon-delete" />
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </section>
  </el-card>
</template>

<script>
  import axios, { RepositoryError } from '../../repositories';
  import { notify } from '../../utils';

  export default {
    name: 'ManageRoles',
    data() {
      return {
        roles: [],
        loading: false,
      };
    },
    created() {
      this.fetch();
    },
    methods: {
      async fetch() {
        try {
          this.loading = true;

          const response = await axios.get('/auth/roles');
          this.roles = response.data;
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        } finally {
          this.loading = false;
        }
      },
      async handleDelete(role) {
        try {
          this.loading = true;
          
          await axios.delete(`/auth/roles/${role.id}`);

          notify(`Deleted role ${role.display_name || role.name}`, 'success');

          const index = this.roles.findIndex(r => r.id === role.id);
          this.roles.splice(index, 1);
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        } finally {
          this.loading = false;
        }
      },
    },
  }
</script>
